import { ViewModel,View } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import  { SettingView } from "./setting-view"

export class SettingViewModel extends WindowViewModel{
    public getTitle(): string {
        return "تنظیمات";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new SettingView();
    }
    public getTypeId(): string {
        return "VM-63BA7FB9-090F-4180-B067-E7EBC60997FB"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set showProductIndexOnPrint(v: boolean) { this._showProductIndexOnPrint = v; } public get showProductIndexOnPrint(): boolean { return this._showProductIndexOnPrint;} private _showProductIndexOnPrint: boolean;
    
    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SettingServices/GetShowProductIndexOnPrintSetting',{});
                this.showProductIndexOnPrint = result.ShowProductIndexOnPrint;
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }

    async toggleShowProductIndexOnPrint() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/SettingServices/ToggleShowProductIndexOnPrint',{
                
            })
            if (result.IsSuccessful){
                this.messageBoxConfirmSuccess("تنظیمات با موفقیت ثبت شد.", "ثبت تغییرات");
                return;
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
}

